package ru.dinarastepina.fabvocab.contracts

import kotlinx.serialization.Serializable

@Serializable
data class WordEntryDto(
    val id: String,
    val word: String,
    val phonetic: String? = null,
    val audioUrl: String? = null,
    val partOfSpeech: String? = null,
    val definitions: List<String> = emptyList(),
    val exampleSentences: List<String> = emptyList(),
    val addedAt: Long,
    val updatedAt: Long = addedAt,
    val isDeleted: Boolean = false,
)
